export class ReactivateAccountRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "domain",
            "baseName": "domain",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ReactivateAccountRequest.attributeTypeMap;
    }
    constructor() {
    }
}
